import React from 'react';
import styles from './FieldErrorMessage.module.scss';
import Text from '../../../BaseModule/Components/Text';

interface Props {
	tx: string;
}

const FieldErrorMessage = ({ tx }: Props) => (
	<div className={styles.errorMessage}>
		<Text tx={tx} inline />
	</div>
);

export default FieldErrorMessage;
